import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ChangePasswordByFindLinkUsecase {
  constructor(private readonly userPasswordRepo: UserPasswordRepository) {}

  async execute(token: string, newPassword: string): Promise<SATResult<void, SATError>> {
    return this.userPasswordRepo.changePasswordByFindLink({
      token,
      newSn: newPassword,
    });
  }
}
